import { Pipe, PipeTransform } from '@angular/core';
import { arrayNotEmpty } from 'src/app/utils/array.utils';
import { FournisseurModelDto } from 'src/graphql/generated-types';

@Pipe({
    name: 'GetSupplierFromId',
    standalone: false
})
export class GetSupplierFromIdPipe implements PipeTransform {

  transform(supplierId: number, suppliersList: FournisseurModelDto[]): FournisseurModelDto {
    return arrayNotEmpty(suppliersList)
        ? suppliersList.find(({IdFournisseur}) => IdFournisseur === supplierId)
        : null;
  }

}
